var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.5C4.30457 0.5 0.5 4.30457 0.5 9C0.5 13.6954 4.30457 17.5 9 17.5C13.6954 17.5 17.5 13.6954 17.5 9C17.5 4.30457 13.6954 0.5 9 0.5ZM7.68822 12.0118C7.59014 12.1099 7.4512 12.1916 7.32861 12.1916C7.20601 12.1916 7.06707 12.1058 6.9649 12.0077L4.67644 9.71923L5.40385 8.99183L7.33269 10.9207L12.4327 5.78389L13.1478 6.52356L7.68822 12.0118Z",
    fill: "#102C98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.0c27a1e7cee34e2fcad128b9783682a4.svg";
export { ForwardRef as ReactComponent };